import(/* webpackMode: "eager", webpackExports: ["CSPostHogProvider"] */ "/app/app/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/app/contexts/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/contexts/BotProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/app/contexts/ModalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/app/contexts/NotificationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/contexts/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/contexts/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/contexts/UserProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/contexts/WorkspaceProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"fallback\":[\"Helvetica\",\"Arial\",\"sans-serif\"],\"variable\":\"--font-plus-jakarta-sans\"}],\"variableName\":\"jakartaSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tooltip/dist/react-tooltip.min.css");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.scss");
